import isEmpty from 'lodash/isEmpty';

import { DEFAULT_LOCALE } from '@/constants';

export const dateFormat = 'DD/MM/YYYY';
export const timeFormat = 'HH:mm';

let formatMessage = null;
let locale = DEFAULT_LOCALE;

export function updateIntl(theLocale, theFormatMessage) {
    formatMessage = theFormatMessage;
    locale = theLocale;
}

export function getLocale() {
    return locale;
}

export function getFormatMessage() {
    return formatMessage;
}

export function formatDateTime(inputDate) {
    if (isEmpty(inputDate)) {
        return null;
    }

    const date = new Date(inputDate);
    if (isNaN(date.getTime())) {
        return null;
    }

    const formatter = new Intl.DateTimeFormat(getLocale(), {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
    });

    return formatter.format(date).toUpperCase();
}
